import {CREATE_TASKS_CONSTANTS} from './constants'

const isIdValid = function(beans, id) {
    if (_.isNull(id))
        return false;

    for (let j = 0; j < beans.length; j++) {
        if (beans[j].id === id)
            return true;
    }
    return false;
};

export const isCustomerIdValid = function(customers, id) {
    if (id === CREATE_TASKS_CONSTANTS.ALL_ACTIVE_CUSTOMERS_OPTION_INDEX)
        return true;
    return isIdValid(customers, id);
};

export const isProjectIdValid = function(projects, id) {
    if (id === CREATE_TASKS_CONSTANTS.ALL_ACTIVE_PROJECTS_OPTION_INDEX)
        return true;
    return isIdValid(projects, id);
};


// WEBPACK FOOTER //
// ./web/js/addNewTasks/utils.js